import {
  SIDEBAR_ITEM_BUTTON_CLASS_NAME,
  SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME,
} from '../../constants/listItemButton';

const sidebarItemButton = ({ theme }) => ({
  minHeight: 48,
  borderTopLeftRadius: theme.spacing(0.25),
  borderBottomLeftRadius: theme.spacing(0.25),
  paddingLeft: theme.spacing(1),
  color: theme.palette.text.primary,

});

const sidebarItemButtonActive = ({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: 'white',
  },
});

const MuiListItemButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${SIDEBAR_ITEM_BUTTON_CLASS_NAME}`]: sidebarItemButton({ theme }),
      [`&.${SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME}`]: {
        ...sidebarItemButton({ theme }),
        ...sidebarItemButtonActive({ theme }),
      },
    }),
  },
};

export default MuiListItemButton;
